module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp12_8003.d18b800a.png";